import { render, staticRenderFns } from "./speed.vue?vue&type=template&id=b6a340fc&scoped=true&"
import script from "./speed.vue?vue&type=script&lang=js&"
export * from "./speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a340fc",
  null
  
)

export default component.exports